import React, { useEffect, useState } from "react";
import { Search, SlidersHorizontal } from "lucide-react";
import CourseCard from "./CourseCard";
import axios from "axios";
import Lottie from "lottie-react";
import Loading from "../../assets/Loading.json";
import { host } from "../../api/ApiCalls";
import { useAuthStore } from "../../store/authStore";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [visibleCount, setVisibleCount] = useState(12);
  const [loading, setLoading] = useState(true);
  const { user } = useAuthStore();
  const userInterests = user?.interests || [];

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`${host}/api/courses`);
        console.log("Fetched courses:", response.data.courses);
        setCourses(response.data.courses);
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  // const filteredCourses = courses?.filter(course => {
  //   const notEnrolled = !course.students?.some(s => s.student === user.id);
  //   const matchesSearch = course.title.toLowerCase().includes(searchQuery.toLowerCase());
  //   const withinPrice = course.price >= priceRange[0] && course.price <= priceRange[1];
  //   return notEnrolled && matchesSearch && withinPrice;
  // });

  // const sortedCourses = filteredCourses?.sort((a, b) => {
  //   const aMatches = a.categories.some(cat => user.interests.includes(cat));
  //   const bMatches = b.categories.some(cat => user.interests.includes(cat));

  //   if (aMatches && !bMatches) return -1;
  //   if (!aMatches && bMatches) return 1;

  //   const aCount = a.students?.length || 0;
  //   const bCount = b.students?.length || 0;

  //   return bCount - aCount;
  // });

  const filteredCourses = courses?.filter((course) => {
    const notEnrolled =
      !user || !course.students?.some((s) => s.student === user.id);
    const matchesSearch = course.title
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    const withinPrice =
      course.price >= priceRange[0] && course.price <= priceRange[1];
    return notEnrolled && matchesSearch && withinPrice;
  });

  const sortedCourses = filteredCourses?.sort((a, b) => {
    const aMatches = user
      ? a.categories.some((cat) => user.interests.includes(cat))
      : false;
    const bMatches = user
      ? b.categories.some((cat) => user.interests.includes(cat))
      : false;

    if (aMatches && !bMatches) return -1;
    if (!aMatches && bMatches) return 1;

    const aCount = a.students?.length || 0;
    const bCount = b.students?.length || 0;

    return bCount - aCount;
  });

  const visibleCourses = sortedCourses?.slice(0, visibleCount);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
        <h1 className="text-3xl font-bold text-gray-800">
          Explore Top Courses
        </h1>

        <div className="flex flex-col md:flex-row items-center gap-4">
          <div className="relative w-full md:w-72">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            <input
              type="text"
              placeholder="Search by title..."
              className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="flex items-center gap-2 w-full md:w-72">
            <SlidersHorizontal className="text-gray-500" />
            <input
              type="range"
              min="0"
              max="1000"
              step="10"
              className="w-full"
              value={priceRange[1]}
              onChange={(e) => setPriceRange([0, Number(e.target.value)])}
            />
            <span className="text-sm text-gray-600 whitespace-nowrap">
              Up to ${priceRange[1]}
            </span>
          </div>
        </div>
      </div>

      {/* {loading ? (
        <div className="flex flex-col items-center justify-center text-gray-800 min-h-screen">
          <div className="w-60">
            <Lottie animationData={Loading} loop={true} />
          </div>
        </div>
      ) : sortedCourses?.length === 0 ? (
        <p className="text-gray-500 text-center pt-20">
          No matching courses found.
        </p>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {visibleCourses.map((course) => (
              <CourseCard key={course._id} course={course} />
            ))}
          </div>
          {visibleCount < sortedCourses.length && (
            <div className="flex justify-center mt-10">
              <button
                onClick={() => setVisibleCount((prev) => prev + 9)}
                className="px-6 py-2 bg-indigo-600 text-white rounded-full shadow-md hover:bg-indigo-700 transition"
              >
                Show More
              </button>
            </div>
          )}
        </>
      )} */}
      {loading ? (
  <div className="flex flex-col items-center justify-center text-gray-800 min-h-screen">
    <div className="w-60">
      <Lottie animationData={Loading} loop={true} />
    </div>
  </div>
) : (
  <div className="min-h-screen">
    {sortedCourses?.length === 0 ? (
      <p className="text-gray-500 text-center pt-20">No matching courses found.</p>
    ) : (
      <>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {visibleCourses.map(course => (
            <CourseCard key={course._id} course={course} />
          ))}
        </div>
        {visibleCount < sortedCourses.length && (
          <div className="flex justify-center mt-10">
            <button
              onClick={() => setVisibleCount(prev => prev + 9)}
              className="px-6 py-2 bg-indigo-600 text-white rounded-full shadow-md hover:bg-indigo-700 transition"
            >
              Show More
            </button>
          </div>
        )}
      </>
    )}
  </div>
)}

    </div>
  );
};

export default Courses;
